// src/context/RepaymentContext.js
import { createContext, useContext, useState } from 'react';

const RepaymentContext = createContext(null);

export function RepaymentProvider({ children }) {
  const [paymentData, setPaymentData] = useState(null);
  const clearPaymentData = () => setPaymentData(null);

  return (
    <RepaymentContext.Provider value={{ paymentData, setPaymentData, clearPaymentData }}>
      {children}
    </RepaymentContext.Provider>
  );
}

export const useRepayment = () => {
  const ctx = useContext(RepaymentContext);
  if (!ctx) throw new Error('useRepayment must be used inside RepaymentProvider');
  return ctx;
};
